import CreateStaff from "./CreateStaff";
import DisplayStaff from "./DisplayStaff";
import { Route } from "react-router-dom";

const routes = {
  key: "STAFF",
  routes: ({ userScope }) => [
    <Route key="staff" path={`${userScope}/staff`}>
      <Route path="creation" key={"staff-creation"} element={<CreateStaff />} />
      <Route key={"staff-display"} path=":slug" element={<DisplayStaff />} />
    </Route>,
  ],
};
export default routes;
